import { Box, Button, Collapse, Typography } from '@mui/material';
import { useState } from 'react';
import { FAIcon } from '@packages/ui-components';

type Props = {
  title: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
};

export function ListSection({ title, onOpenChange, open: externalOpen, children }: Props) {
  const [internalOpen, setInternalOpen] = useState(false);

  const open = externalOpen ?? internalOpen;
  const setOpen = (isOpen: boolean) => {
    setInternalOpen(isOpen);
    onOpenChange?.(isOpen);
  };

  return (
    <Box
      sx={{
        borderRadius: '8px',
        border: '1px solid #EAECF0',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        overflow: 'hidden',
      }}
    >
      <Button
        onClick={() => {
          setOpen(!open);
        }}
        disableRipple
        sx={{
          width: '100%',
          justifyContent: 'flex-start',
          gap: '8px',
          p: '10px 14px',
          backgroundColor: '#F9FAFB !important',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: open ? 'rotate(0deg)' : 'rotate(-180deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          <FAIcon icon="faChevronDown" color="#667085" size={18} />
        </Box>

        <Typography
          sx={{
            color: '#101828',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
          }}
        >
          {title}
        </Typography>
      </Button>

      <Collapse in={open}>
        <Box sx={{ borderTop: '1px solid #EAECF0' }}>{children}</Box>
      </Collapse>
    </Box>
  );
}
